/* Country Road Fashions — the bag drawer (crf-bag.liquid).
   Intercepts the product forms, posts to /cart/add.js with `sections=` so
   Shopify returns the drawer re-rendered, swaps it in and slides it open.
   Everything falls back to the native POST when a request fails, so the
   customer always ends up with the garment in the bag. */
(function () {
  'use strict';

  var root = document.querySelector('[data-crf-bag]');
  if (!root || root.dataset.ready) return;
  root.dataset.ready = '1';

  var sectionId = root.dataset.sectionId;
  var scrim = root.querySelector('[data-crf-bag-scrim]');
  var panel = root.querySelector('[data-crf-bag-panel]');
  var body = root.querySelector('[data-crf-bag-body]');
  var foot = root.querySelector('[data-crf-bag-foot]');
  var title = root.querySelector('.crf-bag__title');
  var live = root.querySelector('[data-crf-bag-live]');
  var closeBtn = root.querySelector('[data-crf-bag-close]');
  var section = root.closest('.shopify-section') || root;
  var lastFocus = null;
  var hideTimer = null;

  function routes() {
    var r = window.routes || {};
    return {
      add: (r.cart_add_url || '/cart/add'),
      change: (r.cart_change_url || '/cart/change'),
      cart: (r.cart_url || '/cart')
    };
  }

  function isOpen() { return panel.classList.contains('is-open'); }

  // ── Rendering ──────────────────────────────────────────────
  function render(html) {
    if (!html) return;
    var doc = new DOMParser().parseFromString(html, 'text/html');
    var next = doc.querySelector('[data-crf-bag]');
    if (!next) return;
    var nextBody = next.querySelector('[data-crf-bag-body]');
    var nextFoot = next.querySelector('[data-crf-bag-foot]');
    if (nextBody) body.replaceChildren.apply(body, Array.prototype.slice.call(nextBody.childNodes));
    if (nextFoot) foot.replaceChildren.apply(foot, Array.prototype.slice.call(nextFoot.childNodes));
    root.dataset.count = next.dataset.count || '0';
    syncHeader(root.dataset.count);
  }

  // The header holds the menu and search state, so it is not re-rendered;
  // only the number changes.
  function syncHeader(n) {
    var count = document.querySelector('[data-crf-bag-count]');
    if (count) count.textContent = n;
    var label = document.querySelector('[data-crf-bag-count-label]');
    if (label) label.textContent = (label.dataset.label || '') + ', ' + n;
  }

  function mark(key) {
    if (!key) return;
    var line = body.querySelector('[data-key="' + (window.CSS && CSS.escape ? CSS.escape(key) : key) + '"]');
    if (!line) return;
    line.classList.add('is-new');
    if (line.scrollIntoView) line.scrollIntoView({ block: 'nearest' });
  }

  function announce() {
    if (!live) return;
    live.textContent = '';
    window.setTimeout(function () { live.textContent = root.dataset.itemAdded || ''; }, 50);
  }

  // ── Open / close ───────────────────────────────────────────
  function setInert(on) {
    Array.prototype.forEach.call(document.body.children, function (el) {
      if (el === section || el.contains(section)) return;
      if (on) el.setAttribute('inert', ''); else el.removeAttribute('inert');
    });
  }

  function open(reason) {
    if (hideTimer) { window.clearTimeout(hideTimer); hideTimer = null; }
    title.textContent = reason === 'added' ? title.dataset.headingAdded : title.dataset.heading;
    if (!isOpen()) lastFocus = document.activeElement;
    scrim.hidden = false;
    panel.hidden = false;
    // A frame between unhide and the class, or the transition never runs.
    window.requestAnimationFrame(function () {
      scrim.classList.add('is-open');
      panel.classList.add('is-open');
    });
    document.body.style.overflow = 'hidden';
    setInert(true);
    if (typeof trapFocus === 'function') trapFocus(panel, closeBtn); else closeBtn.focus();
  }

  function close() {
    if (!isOpen()) return;
    scrim.classList.remove('is-open');
    panel.classList.remove('is-open');
    setInert(false);
    document.body.style.overflow = '';
    body.querySelectorAll('.is-new').forEach(function (el) { el.classList.remove('is-new'); });
    if (typeof removeTrapFocus === 'function') removeTrapFocus(lastFocus);
    else if (lastFocus && lastFocus.focus) lastFocus.focus();
    hideTimer = window.setTimeout(function () {
      scrim.hidden = true;
      panel.hidden = true;
      hideTimer = null;
    }, 450);
  }

  // ── Cart requests ──────────────────────────────────────────
  function add(fd) {
    fd.append('sections', sectionId);
    fd.append('sections_url', window.location.pathname);
    return fetch(routes().add + '.js', {
      method: 'POST',
      body: fd,
      headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' }
    }).then(function (r) { return r.ok ? r.json() : Promise.reject(r); });
  }

  function change(key, quantity) {
    return fetch(routes().change + '.js', {
      method: 'POST',
      headers: { Accept: 'application/json', 'Content-Type': 'application/json' },
      body: JSON.stringify({
        id: key, quantity: quantity,
        sections: sectionId, sections_url: window.location.pathname
      })
    }).then(function (r) { return r.ok ? r.json() : Promise.reject(r); });
  }

  function refresh() {
    return fetch(routes().cart + '?sections=' + encodeURIComponent(sectionId), {
      headers: { Accept: 'application/json' }
    }).then(function (r) { return r.ok ? r.json() : Promise.reject(r); })
      .then(function (json) { render(json[sectionId]); });
  }

  // ── The product forms ──────────────────────────────────────
  function onSubmit(e) {
    if (e.defaultPrevented) return;
    var form = e.currentTarget;
    // Built before the button is touched: the customizer's disabled fields
    // are already left out, so this is exactly the native payload.
    var fd = new FormData(form);
    if (!fd.has('id')) return;
    e.preventDefault();

    var btn = e.submitter || form.querySelector('[name="add"]');
    var label = btn ? btn.textContent : '';
    if (btn) {
      btn.setAttribute('aria-busy', 'true');
      if (root.dataset.adding) btn.textContent = root.dataset.adding;
    }
    function rest() {
      if (!btn) return;
      btn.removeAttribute('aria-busy');
      btn.textContent = label;
    }

    add(fd).then(function (res) {
      rest();
      render(res.sections && res.sections[sectionId]);
      mark(res.key);
      announce();
      open('added');
    }).catch(function () {
      // The native POST reproduces Shopify's own answer, error page included.
      rest();
      form.submit();
    });
  }

  function intercept() {
    document.querySelectorAll('form.crf-buy-form').forEach(function (form) {
      if (form.dataset.crfBag) return;
      form.dataset.crfBag = '1';
      form.addEventListener('submit', onSubmit);
    });
  }

  // ── Wiring ─────────────────────────────────────────────────
  closeBtn.addEventListener('click', close);
  scrim.addEventListener('click', close);
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && isOpen()) close();
  });

  body.addEventListener('click', function (e) {
    var link = e.target.closest('[data-crf-bag-remove]');
    if (!link) return;
    e.preventDefault();
    link.setAttribute('aria-busy', 'true');
    change(link.dataset.crfBagRemove, 0).then(function (res) {
      render(res.sections && res.sections[sectionId]);
      closeBtn.focus();
    }).catch(function () {
      window.location.href = link.href;
    });
  });

  document.querySelectorAll('.crf-masthead__bag').forEach(function (icon) {
    icon.addEventListener('click', function (e) {
      if (root.dataset.openFromHeader !== 'true') return;
      e.preventDefault();
      refresh().catch(function () {}).then(function () { open('view'); });
    });
  });

  intercept();

  // Theme editor: the section re-renders on every setting change.
  document.addEventListener('shopify:section:select', function (e) {
    if (e.target && e.target.contains(root)) open('view');
  });
  document.addEventListener('shopify:section:deselect', function (e) {
    if (e.target && e.target.contains(root)) close();
  });

  window.CRFBag = { open: open, close: close, refresh: refresh, intercept: intercept };
})();
